import { requireBoundCell } from './global/cell-store';
import { isGlobalSurface } from './surface-mode';

export function getPlatformApiUrl(): string {
  if (isGlobalSurface()) return requireBoundCell().origins.platform_api;
  if (import.meta.env.VITE_PLATFORM_API_URL) {
    return import.meta.env.VITE_PLATFORM_API_URL;
  }
  // Use same-origin (empty string) so requests go to hub.localhost, which
  // has a Caddy handler for /platform/v1/*. api.localhost also proxies
  // /platform/v1, but same-origin avoids CORS and is simpler than falling
  // back to VITE_CORE_API_URL.
  return '';
}

const PLATFORM_FINANCE_PATH = '/platform/v1/finance';

/** Base URL for finance metrics and related Platform API routes under `/platform/v1/finance`. */
export function getPlatformFinanceApiBaseUrl(): string {
  const root = getPlatformApiUrl().replace(/\/$/, '');
  if (!root) {
    return PLATFORM_FINANCE_PATH;
  }
  return `${root}${PLATFORM_FINANCE_PATH}`;
}
